class CodeHighlighter {
    static run() {
        hljs.highlightAll();
        window.highlightJsBadge();
    }
}

export default CodeHighlighter;
